import { Boxes, CheckCircle2, Clock, Package, UserRound, XCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { StatCard } from '@/shared/ui/layout/StatCard';
import { formatNumber } from '@/shared/utils/currency';
import type { ApiDashboardGetResponse } from '@/shared/types/api/dashboard';

type Props = { data: ApiDashboardGetResponse };

export const FeaturesDashboardStatsGrid = ({ data }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      <StatCard
        label={t('dashboard.stats.totalParcels')}
        value={formatNumber(data.total_parcels)}
        icon={<Package className="h-5 w-5" aria-hidden />}
        tone="brand"
      />
      <StatCard
        label={t('dashboard.stats.pending')}
        value={formatNumber(data.pending)}
        icon={<Clock className="h-5 w-5" aria-hidden />}
        tone="amber"
      />
      <StatCard
        label={t('dashboard.stats.approved')}
        value={formatNumber(data.approved)}
        icon={<CheckCircle2 className="h-5 w-5" aria-hidden />}
        tone="emerald"
      />
      <StatCard
        label={t('dashboard.stats.rejected')}
        value={formatNumber(data.rejected)}
        icon={<XCircle className="h-5 w-5" aria-hidden />}
        tone="red"
      />
      <StatCard
        label={t('dashboard.stats.parties')}
        value={formatNumber(data.total_parties)}
        icon={<Boxes className="h-5 w-5" aria-hidden />}
        tone="indigo"
      />
      <StatCard
        label={t('dashboard.stats.clients')}
        value={formatNumber(data.total_clients)}
        icon={<UserRound className="h-5 w-5" aria-hidden />}
        tone="slate"
      />
    </div>
  );
};
